"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step3 = void 0;

var react_1 = __importStar(require("react"));

var react_device_detect_1 = require("react-device-detect");

var react_theme_components_1 = require("@suezenv/react-theme-components");

var CheckCodeMandat_1 = require("../../models/CheckCodeMandat");

var ComposedTypo_1 = require("../../components/ComposedTypo/ComposedTypo");

var ComposedLabels_1 = require("../../components/ComposedLabels/ComposedLabels");

var Form_1 = require("../../components/Form");

var referenceFormatter_1 = __importDefault(require("../../utils/referenceFormatter"));

var Input_1 = __importDefault(require("../../components/Form/Input"));

exports.Step3 = function (_a) {
  var goToNextStep = _a.goToNextStep,
      goPreviousStep = _a.goPreviousStep,
      sendBackOtp = _a.sendBackOtp,
      sendBackOtpDisabled = _a.sendBackOtpDisabled,
      loaderSendBackOtp = _a.loaderSendBackOtp,
      messageError = _a.messageError,
      messageSuccess = _a.messageSuccess,
      loaderSubmit = _a.loaderSubmit,
      dataUser = _a.dataUser,
      address = _a.address,
      price = _a.price,
      _b = _a.titulaire,
      titulaire = _b === void 0 ? '' : _b,
      mobile = _a.mobile;
  var sms_code = CheckCodeMandat_1.CheckCodeMandat.sms_code;

  var _c = __read(react_1.useState(false), 2),
      isChecked = _c[0],
      setChecked = _c[1];

  var onChange = function onChange(_a) {
    var target = _a.target;
    setChecked(target.checked);
  };

  var dataUserFormatter = function dataUserFormatter(dataUser) {
    if (!dataUser) {
      return [];
    }

    var formattedDataUser = __spread(dataUser);

    formattedDataUser[1] = referenceFormatter_1.default(formattedDataUser[1]);
    return formattedDataUser;
  };

  return react_1.default.createElement("div", {
    className: "container px-md-5"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h2",
    weight: "bold"
  }, "D\xE9tail du contrat"), react_1.default.createElement(ComposedLabels_1.ComposedLabels, {
    labels: dataUserFormatter(dataUser)
  }), react_1.default.createElement("div", {
    className: "row mt-4 mt-md-5 mb-4 mb-md-5"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "col-12 col-md-3 "
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Nom du titulaire"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, titulaire)), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "col-12 col-md-6 mt-3 mt-md-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Adresse de facturation"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, address)), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "col-12 col-md-3 mt-3 mt-md-0 mt-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Solde \xE0 r\xE9gler"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, price))), react_1.default.createElement(Form_1.Form, {
    onSubmit: goToNextStep,
    validationSchema: CheckCodeMandat_1.CheckCodeMandat,
    initialValues: {}
  }, function (_a) {
    var isValid = _a.isValid;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "row mt-2"
    }, react_1.default.createElement("div", {
      className: "col-md-4"
    }, react_1.default.createElement(Input_1.default, __assign({
      name: 'sms_code'
    }, sms_code)), react_1.default.createElement("div", {
      className: "mr-3 d-none d-md-block"
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      loader: loaderSendBackOtp,
      variant: "tertiary",
      icon: "synchronize-arrow-1",
      onClick: sendBackOtp,
      isDisabled: sendBackOtpDisabled
    }, "Renvoyer le code"))), react_1.default.createElement("div", {
      className: "col-12 col-md-8 mt-1 mt-md-3 px-0 px-md-3"
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "info",
      transparent: true,
      className: "py-2 "
    }, "Un SMS a \xE9t\xE9 envoy\xE9 au num\xE9ro ", mobile, ". Merci de v\xE9rifier sur votre t\xE9l\xE9phone et de saisir le code confidentiel re\xE7u afin de signer votre mandat de pr\xE9l\xE8vement.")), react_1.default.createElement("div", {
      className: "mr-3 col-12 d-block d-md-none"
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      variant: "tertiary",
      icon: "synchronize-arrow-1",
      onClick: sendBackOtp,
      isDisabled: sendBackOtpDisabled
    }, "Renvoyer le code"))), react_1.default.createElement("div", {
      className: "row mt-2 mt-3 mb-md-5"
    }, react_1.default.createElement("div", {
      className: "col-12"
    }, react_1.default.createElement(react_theme_components_1.SzCheckbox, {
      id: "checkbox",
      name: "checkbox",
      label: "Je reconnais avoir pris connaissance des diff\xE9rents \xE9l\xE9ments contenus dans le mandat de pr\xE9l\xE8vement, reconnais leur exactitude et accepte que la saisie du code \xE0 usage unique re\xE7u sur mon t\xE9l\xE9phone portable, associ\xE9e au clic du bouton \"SIGNER LE MANDAT ET PAYER\", vaille signature \xE9lectronique du mandat de pr\xE9l\xE8vement et engagement plein et entier de ma part. J'admets ce mode de signature et je reconnais que mon consentement, formalis\xE9 par ma signature, a \xE9t\xE9 donn\xE9 librement. Je reconnais \xE9galement \xEAtre responsable de la confidentialit\xE9 du code qui m'a \xE9t\xE9 envoy\xE9.",
      type: "checkbox",
      checked: isChecked,
      onChange: onChange
    }))), messageError && react_1.default.createElement("div", {
      className: "row",
      style: {
        marginLeft: '-5.5rem',
        marginRight: '-5.5rem',
        background: 'var(--gray-0)',
        padding: '1rem 5.5rem'
      }
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: 'danger',
      className: 'col-12'
    }, messageError)), messageSuccess && react_1.default.createElement("div", {
      className: "row",
      style: {
        marginLeft: '-5.5rem',
        marginRight: '-5.5rem',
        background: 'var(--gray-0)',
        padding: '1rem 5.5rem'
      }
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: 'success',
      className: 'col-12'
    }, messageSuccess)), react_1.default.createElement("div", {
      className: "row position-relative justify-content-between",
      style: {
        marginLeft: '-5.5rem',
        marginRight: '-5.5rem',
        background: 'var(--gray-0)',
        padding: '1rem 5.5rem'
      }
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      className: "col-2 col-md-4 bg-transparent",
      variant: "secondary",
      icon: "arrow-left",
      onClick: goPreviousStep
    }, react_device_detect_1.isBrowser && 'Étape précédente'), react_1.default.createElement(react_theme_components_1.SzButton, {
      loader: loaderSubmit,
      className: "iban-btn_submit col-7 col-md-4",
      isDisabled: !isValid || !isChecked,
      type: "submit"
    }, "Signer le mandat et payer")));
  }));
};

exports.default = exports.Step3;